export class CartModel {
  constructor() {
    this.items = [];
    this.totals = {
      tax: {},
    };
    this.tracking = null;
    this.id = null;
  }
};